
class CapViewNewRequestForm {
  constructor(config) {
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }

    if (options.schoolYear) {
      return this._checkConfigField('schoolYear', options)
    }
    else if (options.district) {
      return this._checkConfigField('district', options)
    }
    else if (options.partition) {
      return this._checkConfigField('partition', options)
    }
    else if (options.vendor) {
      return this._checkConfigField('vendor', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      return this.config[fieldKey].includes(options[fieldKey])
    }
    else {
      return false
    }
  }

  getSchoolYearOptions() {
    return this.config.schoolYear.options
  }

  getDistrictOptions() {
    return this.config.district.options
  }
}

function key() {
  return 'view_new_request_form'
}

function create(config) {
  return new CapViewNewRequestForm(config)
}

export default {
  key,
  create,
}
